(function () {
  if (window._avaReviewsLoaded) return;
  window._avaReviewsLoaded = true;

  var API_URL = 'https://dash.avareform.org/api/reviews/get-reviews';
  var PRODUCT = window.AVA_PRODUCT_HANDLE || '';
  var TRUNCATE_LENGTH = 280;
  var REVIEWS_PER_PAGE = 5;
  var currentPage = 1;
  var currentSort = 'newest';
  var allReviews = [];

  function fetchReviews(callback) {
    fetch(API_URL + '?product=' + PRODUCT + '&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(null, data); })
      .catch(function (e) { callback(e, null); });
  }

  function renderStars(rating, size) {
    var sizeClass = size === 'lg' ? 'ar-stars--lg' : (size === 'sm' ? 'ar-stars--sm' : '');
    var html = '<span class="ar-stars ' + sizeClass + '">';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="ar-star ' + (i <= rating ? 'ar-star--filled' : '') + '">★</span>';
    }
    html += '</span>';
    return html;
  }

  function formatDate(str) {
    var d = new Date(str + 'T00:00:00');
    return d.toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' });
  }

  function truncate(text, len) {
    if (text.length <= len) return { short: text, full: null };
    return { short: text.slice(0, len).trim(), full: text };
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildCard(review) {
    var initials = review.first_name.charAt(0).toUpperCase() + review.last_name_initial.toUpperCase();
    var name = review.first_name + ' ' + review.last_name_initial + '.';
    var t = truncate(review.body, TRUNCATE_LENGTH);
    var bodyHtml = t.full
      ? '<span class="ar-body-short">' + escHtml(t.short) + '… <button class="ar-read-more" data-id="' + review.id + '">Read more</button></span>'
        + '<span class="ar-body-full ar-hidden">' + escHtml(t.full) + ' <button class="ar-read-less" data-id="' + review.id + '">Read less</button></span>'
      : escHtml(review.body);

    var imageHtml = '';
    if (review.image_url) {
      imageHtml = '<div class="ar-card-image"><img src="' + review.image_url + '" alt="Review photo" class="ar-thumb" data-review-id="' + review.id + '" data-image="' + review.image_url + '"></div>';
    }

    return '<div class="ar-card" data-id="' + review.id + '">'
      + '<div class="ar-card-top">'
      + '<div class="ar-card-author">'
      + '<div class="ar-avatar">' + escHtml(initials) + '</div>'
      + '<div class="ar-card-name">' + escHtml(name) + ' <span class="ar-verified"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="6" fill="#3a7d52"/><path d="M3.5 6L5 7.5L8.5 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified Buyer</span></div>'
      + '</div>'
      + '<div class="ar-card-date">' + formatDate(review.review_date) + '</div>'
      + '</div>'
      + '<div class="ar-card-rating-row">'
      + renderStars(review.rating, 'md')
      + '<span class="ar-card-title">' + escHtml(review.title) + '</span>'
      + '</div>'
      + '<div class="ar-card-body" data-id="' + review.id + '">' + bodyHtml + '</div>'
      + imageHtml
      + '</div>';
  }

  function buildStatsHeader(data) {
    var el = document.getElementById('ar-stats-header');
    if (!el) return;
    if (data.total_count === 0) { el.style.display = 'none'; return; }

    var avg = data.average_rating.toFixed(1);
    var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    data.reviews.forEach(function (r) {
      dist[r.rating] = (dist[r.rating] || 0) + 1;
    });

    var barsHtml = '';
    for (var i = 5; i >= 1; i--) {
      var count = dist[i] || 0;
      var pct = data.total_count > 0 ? Math.round((count / data.total_count) * 100) : 0;
      barsHtml += '<div class="ar-dist-row">'
        + '<span class="ar-dist-label">' + i + ' <span class="ar-dist-star">★</span></span>'
        + '<div class="ar-dist-bar-wrap"><div class="ar-dist-bar" style="width:' + pct + '%"></div></div>'
        + '<span class="ar-dist-count">' + count + '</span>'
        + '</div>';
    }

    el.innerHTML = '<div class="ar-stats-left">'
      + '<div class="ar-avg-score">' + avg + '</div>'
      + renderStars(Math.round(data.average_rating), 'lg')
      + '<div class="ar-stats-based">Based on ' + data.total_count + ' review' + (data.total_count !== 1 ? 's' : '') + '</div>'
      + '</div>'
      + '<div class="ar-stats-right">' + barsHtml + '</div>';

    el.style.display = 'flex';
  }

  function buildSummary(data) {
    var el = document.getElementById('ar-summary');
    if (!el) return;
    if (data.total_count === 0) { el.style.display = 'none'; return; }
    var avg = data.average_rating.toFixed(1);
    el.innerHTML = renderStars(Math.round(data.average_rating), 'sm')
      + '<span class="ar-summary-avg">' + avg + '</span>'
      + '<a class="ar-summary-count" href="#ava-reviews">' + data.total_count + ' review' + (data.total_count !== 1 ? 's' : '') + '</a>';
    el.style.display = 'flex';
  }

  function getSortedReviews() {
    var sorted = allReviews.slice();
    if (currentSort === 'highest') {
      sorted.sort(function (a, b) { return b.rating - a.rating; });
    } else if (currentSort === 'lowest') {
      sorted.sort(function (a, b) { return a.rating - b.rating; });
    } else if (currentSort === 'newest') {
      sorted.sort(function (a, b) { return new Date(b.review_date) - new Date(a.review_date); });
    } else if (currentSort === 'oldest') {
      sorted.sort(function (a, b) { return new Date(a.review_date) - new Date(b.review_date); });
    }
    return sorted;
  }

  function renderPage() {
    var listEl = document.getElementById('ar-list');
    var pagEl = document.getElementById('ar-pagination');
    if (!listEl) return;

    var sorted = getSortedReviews();
    var totalPages = Math.ceil(sorted.length / REVIEWS_PER_PAGE);
    if (currentPage > totalPages) currentPage = 1;

    var start = (currentPage - 1) * REVIEWS_PER_PAGE;
    var pageReviews = sorted.slice(start, start + REVIEWS_PER_PAGE);

    listEl.innerHTML = pageReviews.map(buildCard).join('');
    bindCardEvents(sorted);

    if (!pagEl) return;
    pagEl.innerHTML = '';
    if (totalPages <= 1) return;

    getPageItems(totalPages, currentPage).forEach(function (page) {
      if (page === null) {
        var gap = document.createElement('span');
        gap.className = 'ar-page-ellipsis';
        gap.textContent = '…';
        pagEl.appendChild(gap);
        return;
      }
      var btn = document.createElement('button');
      btn.className = 'ar-page-btn' + (page === currentPage ? ' ar-page-btn--active' : '');
      btn.textContent = page;
      btn.addEventListener('click', function () {
        currentPage = page;
        renderPage();
        var section = document.getElementById('ava-reviews');
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      pagEl.appendChild(btn);
    });
  }

  function getPageItems(total, current) {
    var items = [];
    var i;
    if (total <= 7) {
      for (i = 1; i <= total; i++) items.push(i);
      return items;
    }
    var start = Math.max(2, current - 1);
    var end = Math.min(total - 1, current + 1);
    if (current <= 3) { start = 2; end = 4; }
    if (current >= total - 2) { start = total - 3; end = total - 1; }
    items.push(1);
    if (start > 2) items.push(null);
    for (i = start; i <= end; i++) items.push(i);
    if (end < total - 1) items.push(null);
    items.push(total);
    return items;
  }

  function buildList(data) {
    var listEl = document.getElementById('ar-list');
    var emptyEl = document.getElementById('ar-empty');
    if (!listEl) return;

    allReviews = data.reviews || [];

    if (data.total_count === 0) {
      listEl.innerHTML = '';
      var pagEl = document.getElementById('ar-pagination');
      if (pagEl) pagEl.innerHTML = '';
      if (emptyEl) {
        if (!emptyEl.textContent.trim()) emptyEl.textContent = 'No reviews yet. Be the first to share your experience.';
        emptyEl.style.display = 'block';
      }
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    renderPage();
  }

  function bindCardEvents(reviews) {
    document.querySelectorAll('.ar-read-more').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.id;
        var card = document.querySelector('.ar-card-body[data-id="' + id + '"]');
        if (!card) return;
        card.querySelector('.ar-body-short').classList.add('ar-hidden');
        card.querySelector('.ar-body-full').classList.remove('ar-hidden');
      });
    });

    document.querySelectorAll('.ar-read-less').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.id;
        var card = document.querySelector('.ar-card-body[data-id="' + id + '"]');
        if (!card) return;
        card.querySelector('.ar-body-full').classList.add('ar-hidden');
        card.querySelector('.ar-body-short').classList.remove('ar-hidden');
      });
    });

    document.querySelectorAll('.ar-thumb').forEach(function (img) {
      img.addEventListener('click', function () {
        var rid = img.dataset.reviewId;
        var review = reviews.find(function (r) { return String(r.id) === String(rid); });
        if (!review) return;
        openImagePopup(review, img.dataset.image);
      });
    });
  }

  function openImagePopup(review, imageUrl) {
    var overlay = document.getElementById('ar-popup-overlay');
    if (!overlay) return;
    var name = review.first_name + ' ' + review.last_name_initial + '.';
    document.getElementById('ar-popup-image').src = imageUrl;
    document.getElementById('ar-popup-name').textContent = name;
    document.getElementById('ar-popup-date').textContent = formatDate(review.review_date);
    document.getElementById('ar-popup-stars').innerHTML = renderStars(review.rating, 'sm');
    document.getElementById('ar-popup-title').textContent = review.title;
    document.getElementById('ar-popup-body').textContent = review.body;
    overlay.classList.remove('ar-hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeImagePopup() {
    var overlay = document.getElementById('ar-popup-overlay');
    if (!overlay) return;
    overlay.classList.add('ar-hidden');
    document.body.style.overflow = '';
  }

  function bindPopupEvents() {
    var overlay = document.getElementById('ar-popup-overlay');
    if (!overlay) return;
    var closeBtn = document.getElementById('ar-popup-close');
    if (closeBtn) closeBtn.addEventListener('click', closeImagePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeImagePopup();
    });
  }

  function openFormModal() {
    var modal = document.getElementById('ar-form-modal');
    if (!modal) return;
    modal.classList.remove('ar-hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeFormModal() {
    var modal = document.getElementById('ar-form-modal');
    if (!modal) return;
    modal.classList.add('ar-hidden');
    document.body.style.overflow = '';
  }

  function bindFormModalEvents() {
    var openBtn = document.getElementById('ar-open-form');
    if (openBtn) openBtn.addEventListener('click', openFormModal);

    var closeBtn = document.getElementById('ar-form-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeFormModal);

    var modal = document.getElementById('ar-form-modal');
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeFormModal();
      });
    }
  }

  function bindSortEvents() {
    var select = document.getElementById('ar-sort-select');
    if (!select) return;
    select.addEventListener('change', function () {
      currentSort = select.value;
      currentPage = 1;
      renderPage();
    });
  }

  function bindFormEvents() {
    var form = document.getElementById('ar-form');
    if (!form) return;

    var stars = form.querySelectorAll('.ar-form-star');
    var ratingInput = form.querySelector('input[name="rating"]');

    stars.forEach(function (star) {
      star.addEventListener('mouseover', function () {
        var val = parseInt(star.dataset.value);
        stars.forEach(function (s) {
          s.classList.toggle('ar-star--filled', parseInt(s.dataset.value) <= val);
        });
      });
      star.addEventListener('mouseleave', function () {
        var current = parseInt(ratingInput.value) || 0;
        stars.forEach(function (s) {
          s.classList.toggle('ar-star--filled', parseInt(s.dataset.value) <= current);
        });
      });
      star.addEventListener('click', function () {
        ratingInput.value = star.dataset.value;
        stars.forEach(function (s) {
          s.classList.toggle('ar-star--filled', parseInt(s.dataset.value) <= parseInt(star.dataset.value));
        });
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('.ar-form-submit');
      if (submitBtn && submitBtn.disabled) return;

      var msg = document.getElementById('ar-form-msg');
      msg.textContent = '';
      msg.className = 'ar-form-msg';

      var rating = ratingInput.value;
      if (!rating || rating < 1 || rating > 5) {
        msg.textContent = 'Please select a star rating.';
        msg.classList.add('ar-form-msg--error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      var fd = new FormData(form);
      fd.set('product_handle', PRODUCT);

      fetch('https://dash.avareform.org/api/reviews/submit', {
        method: 'POST',
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.success) {
            form.reset();
            ratingInput.value = '';
            stars.forEach(function (s) { s.classList.remove('ar-star--filled'); });
            msg.textContent = '';
            msg.className = 'ar-form-msg';

            var successDiv    = document.getElementById('ar-form-success');
            var formTitle     = document.querySelector('#ar-form-modal .ar-form-title');
            var modalCloseBtn = document.getElementById('ar-form-modal-close');

            if (successDiv) {
              form.style.display                         = 'none';
              if (formTitle)     formTitle.style.display = 'none';
              if (modalCloseBtn) modalCloseBtn.style.display = 'none';
              successDiv.style.display = 'flex';
            }

            function restoreModal() {
              clearTimeout(autoCloseTimer);
              closeFormModal();
              setTimeout(function () {
                form.style.display = '';
                if (formTitle)     formTitle.style.display = '';
                if (modalCloseBtn) modalCloseBtn.style.display = '';
                if (successDiv)    successDiv.style.display = 'none';
              }, 300);
            }

            var autoCloseTimer = setTimeout(restoreModal, 3000);

            var successCloseBtn = document.getElementById('ar-success-close');
            if (successCloseBtn) {
              var newBtn = successCloseBtn.cloneNode(true);
              successCloseBtn.parentNode.replaceChild(newBtn, successCloseBtn);
              newBtn.addEventListener('click', restoreModal);
            }
          } else {
            msg.textContent = data.message || 'Something went wrong. Please try again.';
            msg.classList.add('ar-form-msg--error');
          }
        })
        .catch(function () {
          msg.textContent = 'Something went wrong. Please try again.';
          msg.classList.add('ar-form-msg--error');
        })
        .finally(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Review';
        });
    });
  }

  function getEmbeddedData() {
    var el = document.getElementById('ar-data');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      if (!d || !d.reviews || !d.reviews.length) return null;
      return {
        success: true,
        total_count: d.reviews.length,
        reviews: d.reviews.map(function (r) {
          return {
            id: r.id,
            first_name: String(r.name || '').replace(/\s+\S*\.$/, ''),
            last_name_initial: String(r.initials || '').slice(1),
            rating: r.rating,
            title: r.title || '',
            body: r.body || '',
            review_date: r.date,
            image_url: r.image_url || ''
          };
        })
      };
    } catch (e) {
      return null;
    }
  }

  function init() {
    var spinner = document.getElementById('ar-spinner');
    if (spinner) spinner.style.display = 'block';

    fetchReviews(function (err, data) {
      if (spinner) spinner.style.display = 'none';
      if (err || !data || !data.success) {
        var embedded = getEmbeddedData();
        if (embedded) buildList(embedded);
        return;
      }
      buildSummary(data);
      buildStatsHeader(data);
      buildList(data);
    });

    bindPopupEvents();
    bindFormModalEvents();
    bindSortEvents();
    bindFormEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();